module.exports = __webpack_public_path__ + "static/media/icon-check-circle.9d5a1fde.svg";